import React from "react"
import SummaryRow from "./summary-row"
import SummaryCosts from "./summary-costs"
import "./summary-table.scss"
import { useEFSData } from "hooks/efs-input"
import StringInject from "stringinject"
import { PropTypes } from "prop-types"

const SummaryTable = ({
  deviceSummary,
  planSummary,
  extrasSummary,
  totalCosts,
  excludeVAT,
  vatDivider
}) => {
  // MORRRE HACKS - HACK Yeah
  const { haveHalo } = useEFSData()

  const templateData = {
    currentHalo: haveHalo === 1 ? "+ Halo 1" : " ",
    haloUpgrade: haveHalo === 1 ? "+ Halo 3" : "+ Halo 1"
  }

  planSummary.text = StringInject(planSummary.text, templateData)

  return (
    <>
      <table className="summary-table">
        <thead>
          <tr>
            <th colSpan="2" />
            <th className="monthly-cost">Duration</th>
            <th className="upfront-cost">Upfront cost</th>
            <th className="monthly-cost">Monthly cost</th>
          </tr>
          <tr>
            <th colSpan="5" className="package-heading">
              Your Package
            </th>
          </tr>
        </thead>
        <tbody>
          <SummaryRow
            image={deviceSummary.img}
            rowSpan={3 + extrasSummary.length}
            text={deviceSummary.text}
            costs={deviceSummary.costs}
            excludeVAT={excludeVAT}
          />
          <SummaryRow
            heading={`${planSummary.duration} months`}
            text={`${planSummary.text}`}
            costs={planSummary.costs}
            excludeVAT={excludeVAT}
          />
          {planSummary.entertainmentCost !== 0 && (
            <SummaryRow
              heading={"Entertainment"}
              text={planSummary.entertainmentDetails.mainText}
              costs={{
                monthly: planSummary.entertainmentDetails.monthly
              }}
              excludeVAT={excludeVAT}
            />
          )}
          {extrasSummary.map((extra, index) => (
            <SummaryRow
              key={index}
              label="Extra"
              text={extra.text}
              costs={extra.costs}
              excludeVAT={excludeVAT}
            />
          ))}
        </tbody>
      </table>
      <SummaryCosts costs={totalCosts} vatDivider={vatDivider} />
    </>
  )
}

SummaryTable.propTypes = {
  deviceSummary: PropTypes.object.isRequired,
  planSummary: PropTypes.object.isRequired,
  extrasSummary: PropTypes.array.isRequired,
  totalCosts: PropTypes.object.isRequired,
  excludeVAT: PropTypes.bool,
  vatDivider: PropTypes.number
}

export default SummaryTable
